// extracted by mini-css-extract-plugin
export var backgroundImage = "_j-1";
export var container = "_j-0";
export var title = "_j-2";